import AuthenticationService from 'services/authentication';

const sendVerificationEmail = async () => {
  await AuthenticationService.sendVerificationEmail();
};

export default sendVerificationEmail;
